"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockTournamentResults = {
    success: true,
    tournamentData: {
        name: 'leaderboard test',
        dateTime: '2023-06-06T09:00:00.000Z',
        numberOfRounds: 1,
        participants: 3,
        winner: 'Ronit User',
        frameworks: ['.NET', 'Java', 'Node.JS'],
    },
    userResults: {
        rank: 2,
        score: 3963,
        vulnerabilities: [
            {
                vulnerabilityName: 'Race Condition',
                rating: 100,
            },
            {
                vulnerabilityName: 'XXE Processing',
                rating: 100,
            },
            {
                vulnerabilityName: 'Horizontal Privilege Escalation',
                rating: 0,
            },
            {
                vulnerabilityName: 'SQL Injection',
                rating: 0,
            },
            {
                vulnerabilityName: 'Use of Insufficiently Random Values',
                rating: 0,
            },
            {
                vulnerabilityName: 'Insecure Password Storage',
                rating: 0,
            },
            {
                vulnerabilityName: 'Reflected XSS',
                rating: 0,
            },
            {
                vulnerabilityName: 'OS Command Injection',
                rating: 0,
            },
            {
                vulnerabilityName: 'Cross Site Request Forgery',
                rating: 0,
            },
        ],
    },
    questionsBreakdown: [
        [
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'OS Command Injection',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'Horizontal Privilege Escalation',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'Cross Site Request Forgery',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'SQL Injection',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'SQL Injection',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'Reflected XSS',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'Use of Insufficiently Random Values',
            },
            {
                correct: false,
                allUsersSuccess: 0,
                vulnerabilityName: 'Insecure Password Storage',
            },
            {
                correct: true,
                allUsersSuccess: 100,
                vulnerabilityName: 'Race Condition',
            },
            {
                correct: true,
                allUsersSuccess: 100,
                vulnerabilityName: 'XXE Processing',
            },
        ],
    ],
    framework: 'Java',
};
exports.default = mockTournamentResults;
